import SiteHeader from "./components/SiteHeader";
import HeroSection from "./components/HeroSection";
import OverviewSection from "./components/OverviewSection";
import ArtStylesSection from "./components/ArtStylesSection";
import WorksSection from "./components/WorksSection";
import CharactersSection from "./components/CharactersSection";
import GuideSection from "./components/GuideSection";
import CommunitySection from "./components/CommunitySection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <OverviewSection />
        <ArtStylesSection />
        <WorksSection />
        <CharactersSection />
        <GuideSection />
        <CommunitySection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}